export const paths = {
    home: '/',
    item: '/item',
    createItem: '/create-item',
    order: '/order',
    loginAdmin: '/login-admin'
}